import React, { useEffect, useState } from "react";
import { Element } from "react-scroll";
import about from "../../assets/img/istockphoto-1402604850-170667a.webp";
import classes from "./About.module.css";

const About = () => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const aboutSection = document.getElementById("about");
      if (!aboutSection) return;

      const sectionTop = aboutSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (sectionTop < windowHeight * 0.75) {
        setShowContent(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // run once on load

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className={classes.section} aria-labelledby="about-heading">
      {/* Section Title */}
      <div className="section-title">
        <h1 id="about-heading" className="section-heading">
          About Us
        </h1>
        <h5 className="section-subheading">WHO WE ARE</h5>
      </div>

      {/* Content */}
      <Element
        id="about"
        className={`${classes["about-content"]} ${
          showContent ? classes.show : ""
        }`}
      >
        <div className={classes["about-image"]}>
          <img
            src={about}
            alt="About IQApex Labs"
            loading="lazy"
          />
        </div>

        <div className={classes["about-text"]}>
          <p>
            IQApex Labs is an IT services and software development firm focused on
            building scalable web and mobile applications, blockchain solutions,
            and digital platforms. We have successfully delivered projects
            across multiple industries and are also known for our
            research-driven product development expertise.
          </p>

          <button
            onClick={() => (window.location.href = "/aboutUs")}
            aria-label="Learn more about IQApex Labs"
          >
            Learn More
          </button>
        </div>
      </Element>
    </section>
  );
};

export default About;
